import { gql } from '@apollo/client';

export const GetFilters = gql`
    query Filters {
        filters {
            instruments {
                code
                subFilters {
                    code
                }
            }
            genres {
                code
                subFilters {
                    code
                }
            }
            sfxs {
                code
                subFilters {
                    code
                }
            }
            tags {
                code
                label
            }
            sampleTypes {
                code
            }
        }
    }
`;
